import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import sdfa from './sdfa';
import events from './events';
import doa from './doa';

import { ACTIONS } from 'forms/actions/';

export function loadForm(state, action) {
    if (!action || action.type !== ACTIONS.FORMS_LOAD_FORM_KEY) {
        return state;
    }

    const result = { ...state };
    const form = lodash.get(action, 'payload', {});
    lodash.set(result, 'form.formKey', form.key);
    lodash.set(result, 'form.name', form.name);

    return result;
}

const formReducer = composeReducers(
    loadForm,
    sdfa,
    events,
    doa,
);

export default formReducer;
